module.exports = __webpack_public_path__ + "static/media/close.bebc4565.svg";